import { useCallback } from 'react';
import { rage, useObservable } from '~/rage';

import { ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { ShopBalance } from '~/components/ui/ShopBalance';
import { ListHorizontal } from '../../components/ListHorizontal';
import { ParkingSlotsInfo } from '../../components/ParkingSlotsInfo';
import { StyledBarContainer } from './Header.styled';

const Header = (props: React.HTMLAttributes<HTMLDivElement>) => {
	const currentModal = useObservable(rage.modal.getCurrentModal());

	const handleCloseButton = useCallback(() => {
		if (currentModal) {
			return;
		}

		rage.vehicleShop
			.exitShop()
			.catch((err) => rage.notifications.showException(err));
	}, [currentModal]);

	return (
		<StyledBarContainer {...props}>
			<ListHorizontal>
				<ParkingSlotsInfo />
				<ShopBalance />
			</ListHorizontal>
			<CloseButton height={ButtonHeight.Height40} onClick={handleCloseButton} />
		</StyledBarContainer>
	);
};

export { Header };
